export const Equals = {
	equals(objectOne: any, objectTwo: any) {
		if (objectOne === objectTwo) {
			return true;
		}
		// if both objectOne and ObjectTwo are null or undefined and exactly the same
		if (!(objectOne instanceof Object) || !(objectTwo instanceof Object)) {
			return false;
		}
		// if they are not strictly equal, they both need to be Objects
		if (objectOne.constructor !== objectTwo.constructor) {
			return false;
		}
		// they must have the exact same prototype chain, the closest we can do is
		// test their constructor.

		let property;
		for (property in objectOne) {
			if (!objectOne.hasOwnProperty(property)) {
				continue;
			}
			// other properties were tested using ObjectOne.constructor === ObjectTwo.constructor
			if (!objectTwo.hasOwnProperty(property)) {
				return false;
			}
			// allows to compare ObjectOne[property] and ObjectTwo[property] when set to undefined
			if (objectOne[property] === objectTwo[property]) {
				continue;
			}
			// if they have the same strict value or identity then they are equal
			if (typeof (objectOne[property]) !== 'object') {
				return false;
			}
			// Numbers, Strings, Functions, Booleans must be strictly equal
			if (!this.equals(objectOne[property], objectTwo[property])) {
				return false;
			}
		}
		for (property in objectTwo) {
			if (objectTwo.hasOwnProperty(property) && !objectOne.hasOwnProperty(property)) {
				return false;
			}
		}
		return true;
	}
};
